<template>
  <div class="concern-card border rounded p-3 mb-2" :class="cardClass">
    <div class="d-flex justify-content-between align-items-start">
      <div class="flex-grow-1 mr-3">
        <div class="d-flex align-items-center mb-1">
          <severity-badge :severity="concern.severity" class="mr-2" />
          <span v-if="concern.product" class="text-muted">
            {{ concern.product.product }}
          </span>
        </div>
        <h6 class="mb-1 font-weight-semibold">{{ concern.title }}</h6>
        <p class="mb-0 text-muted">{{ concern.description }}</p>
      </div>
      <div class="d-flex flex-column align-items-end concern-actions">
        <span class="badge badge-light text-muted mb-2">{{ concern.concern_code }}</span>
        <b-dropdown
          v-if="concern.status === 'ACTIVE'"
          no-caret
          right
          variant="link"
          toggle-class="p-0 text-muted"
          class="concern-menu"
        >
          <template #button-content>&#8942;</template>
          <b-dropdown-item @click="$emit('view', concern)">View details</b-dropdown-item>
          <b-dropdown-item @click="$emit('snooze', concern)" :disabled="acting">Snooze</b-dropdown-item>
          <b-dropdown-item @click="$emit('resolve', concern)" :disabled="acting">Resolve</b-dropdown-item>
        </b-dropdown>
        <small class="text-muted mt-1">{{ formatRelative(concern.last_seen_at) }}</small>
      </div>
    </div>

    <div v-if="concern.recurrence_count > 0" class="mt-2">
      <small class="text-warning">
        <i class="bi bi-arrow-repeat"></i> Recurred {{ concern.recurrence_count }} time{{ concern.recurrence_count !== 1 ? 's' : '' }}
      </small>
    </div>
  </div>
</template>

<script>
import SeverityBadge from './SeverityBadge.vue';
import { SEVERITY_BORDER_CLASS } from './constants.js';

export default {
  name: 'ConcernCard',
  components: { SeverityBadge },
  props: {
    concern: { type: Object, required: true },
    acting: { type: Boolean, default: false },
  },
  computed: {
    cardClass() {
      return [SEVERITY_BORDER_CLASS[this.concern.severity] || '', 'concern-card-inner'];
    },
  },
  methods: {
    formatRelative(dateStr) {
      if (!dateStr) return '';
      const diff = Date.now() - new Date(dateStr).getTime();
      const mins = Math.floor(diff / 60000);
      if (mins < 60)  return `${mins}m ago`;
      const hrs = Math.floor(mins / 60);
      if (hrs < 24)   return `${hrs}h ago`;
      return `${Math.floor(hrs / 24)}d ago`;
    },
  },
};
</script>

<style scoped>
.concern-card {
  background: #fff;
  transition: box-shadow 0.15s;
}
.concern-card:hover {
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}
.concern-actions {
  min-width: 60px;
}
</style>
